import { Component } from '@angular/core';

/**
 * Página informativa del comercio para el convenio de Toka.
 *
 * Es la URL que se envía en el campo `url` de getSignSms / signAgreement y que
 * Toka muestra como enlace dentro de su pantalla de autorización. Su guía exige
 * que esté en español.
 *
 * A propósito NO lleva el importe escrito: el monto y el límite autorizado los
 * muestra la propia pantalla de Toka al firmar, y duplicarlos aquí garantizaría
 * que tarde o temprano se contradigan.
 */
@Component({
    selector: 'msc-toka-suscripcion',
    templateUrl: './toka-suscripcion.component.html',
    styleUrls: ['./toka-suscripcion.component.scss'],
})
export class TokaSuscripcionComponent {
}
